import { useTranslation } from 'react-i18next';

import { compressorTypes, DeviceType } from '@/constants/deviceTypeEnum';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';
import PoweredOnIcon from '@/comp/common/icons/PoweredOnIcon';
import PoweredOffIcon from '@/comp/common/icons/PoweredOffIcon';
import { getPoweredOnState } from '@/comp/StationControlCenter/SccUtils';

import { usePowerOnOffVisibility } from '../Footer/StartStopButtons/StartStopButtons.utils';
import { PoweredOnIndicationContainer } from './PoweredOnIndication.styles';

const PoweredOnIndication = ({ entity }: { entity: Entity }) => {
  const { t } = useTranslation();
  const { poweredOn, deviceType, deviceId } = entity;

  const poweredOnState = getPoweredOnState(poweredOn);

  const { poweredOnMetricPresent, powerChangeSupportedAction } = usePowerOnOffVisibility(deviceId);
  const shouldNotDisplayPoweredOnIndication =
    !poweredOnMetricPresent || !powerChangeSupportedAction || !compressorTypes.includes(deviceType as DeviceType);

  if (shouldNotDisplayPoweredOnIndication) return null;

  return (
    <PoweredOnIndicationContainer>
      {poweredOnState ? <PoweredOnIcon /> : <PoweredOffIcon />}
      <span className="powered-on-text">
        {t('compressor')}&nbsp;
        <span className="on-off-text">{poweredOnState ? t('ON') : t('OFF')}</span>
      </span>
    </PoweredOnIndicationContainer>
  );
};

export default PoweredOnIndication;
